@if (label) {
  <label class="label-above" [for]="id">
    {{ label | translate }}
  </label>
}
<div class="form-select" [ngClass]="{'active': selectActive}">
  <app-svg-icon class="arrow" [path]="'assets/icons/chevron-down.svg'"></app-svg-icon>
  <select
    (click)="onClickSelect()"
    (keydown)="onKeydownSelect($event)"
    (change)="onChangeSelect($any($event.target))"
    [id]="id"
    [disabled]="disabled"
    >
    @for (option of options$ | async; track trackByFunction($index, option)) {
      @if ({ value: showFor$ | async}; as showFor) {
        @if (showFor.value ? option.showFor?.includes(showFor.value) : true) {
          <option
            [value]="option.value"
            [selected]="option.selected"
            >
            {{ option.text | translate }}
          </option>
        }
      }
    }
  </select>
</div>
<div
  class="form-select-background"
  [ngClass]="{'active': selectActive}"
  (click)="onClickSelect()">
</div>